<template>
    <div class='egg'>
        <div class="egg-bd">
            <div class="egg-bd-one">
                <img :src="aliApplyUrl+'egg/egg-pc-01.jpg'" class="egg-img" alt=""/>
            </div>
            <div class="egg-bd-two rel">
                <div class="egg-list">
                    <div class="egg-list-col" @click="jump(0)"></div>
                    <div class="egg-list-col" @click="jump(1)"></div>
                    <div class="egg-list-col" @click="jump(2)"></div>
                    <div class="egg-list-col" @click="jump(3)"></div>
                </div>
                <img :src="aliApplyUrl+'egg/egg-pc-02.jpg'" class="egg-img" alt=""/>
            </div>
            <div class="egg-bd-three d_jump">
                <router-link :to="{name: 'myQuestionDetail',params:{code:'egg-protocol'}}">
                    <img :src="aliApplyUrl+'egg/egg-pc-03.jpg'" class="egg-img" alt=""/>
                </router-link>
            </div>
            <div class="egg-bd-four d_jump">
                <img :src="aliApplyUrl+'egg/egg-pc-04.jpg'" class="egg-img" alt=""/>
            </div>
            <div class="egg-bd-five d_jump">
                <img :src="aliApplyUrl+'egg/egg-pc-05.jpg'" class="egg-img" alt=""/>
            </div>
            <div class="egg-bd-six d_jump">
                <img :src="aliApplyUrl+'egg/egg-pc-06.jpg'" class="egg-img" alt=""/>
            </div>
            <div class="egg-bd-seven rel">
                <img :src="aliApplyUrl+'egg/egg-11.png'" alt=""
                     class="egg-bd-seven-btn"
                     @click="handleOpen"/>
                <img :src="aliApplyUrl+'egg/egg-pc-07.jpg'" class="egg-img" alt=""/>
            </div>

        </div>
        <Modal
                v-model="hasSuccess"
                :closable="false"
                class="egg-modal">
            <div class="egg-modal-content rel">
                <img :src="aliApplyUrl+'egg/egg-pc-12.png'" class="egg-modal-content-img rel" alt=""/>
                <div class="egg-close" @click="handleClose"></div>
                <div class="egg-num">{{egg.point}}</div>
                <div class="egg-phone">已存入 <span class="egg-phone-text">{{egg.mobilePhone}}</span> 账户内</div>
                <router-link :to="{name:'myEggPurchase'}">
                    <button class="egg-app"></button>
                </router-link>
                <button @click="handleShare" class="egg-share"></button>
            </div>
        </Modal>
        <Modal
                v-model="hasPhone"
                :closable="false"
                class="egg-modal-phone"
        >
            <div class="egg-modal-phone-content rel">
                <div class="phone-hd rel">
                    登录
                    <div class="phone-hd-close" @click="handleClosePhone">
                        <i class="ivu-icon ivu-icon-ios-close-empty"></i>
                    </div>
                </div>
                <div class="phone-bd mt20">
                    <div class="mt20 phone-input">
                        <input type="number" placeholder="输入手机号码" style="width: 240px" v-model="phone">
                    </div>
                    <div class="mt20 phone-input">
                        <div class="dib">
                            <input type="number" placeholder="验证码" v-model="code">
                        </div>
                        <div class="dib">
                            <button class="ml10 button-egg" :disabled="hasCode" @click="handleCode">
                                {{hasCode ? timer + 's' : '获取验证码'}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="phone-fd mt15">
                    <button class="button button-egg-bg" @click="handleLogin">立即登录</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import api from '../../../../../src/api'
    import vStroe from 'vue-store'

    export default {
        data() {
            return {
                aliApplyUrl: 'https://chain-apply.oss-cn-shanghai.aliyuncs.com/',
                hasSuccess: false,
                hasPhone: false,
                hasCode: false,
                phone: '',
                code: '',
                timer: 60,
                egg: {}
            };
        },
        components: {},
        methods: {
            handleClose() {
                this.hasSuccess = false;
            },
            handleOpen() {
                this.handleLuckDraw();
            },
            handleLuckDraw() {
                const {token} = vStroe.local;
                let _self = this;
                if (token && token != undefined && token != 'undefined') {
                    api.points.eggLuckDraw().then(res => {
                        this.egg = res;
                        setTimeout(() => {
                            _self.hasSuccess = true;
                        }, 300);
                    });
                } else {
                    this.hasPhone = true;
                }
            },
            handleClosePhone() {
                this.hasPhone = false;
            },
            handleLogin() {
                if (!this.phone) {
                    this.$Message.error('请输入手机号码');
                    return false;
                }
                if (!this.code) {
                    this.$Message.error('请输入验证码');
                    return false;
                }
                api.account.login_quick({
                    'phone': this.phone,
                    'code': this.code,
                    'unionid': '',
                    'messageType': 3
                })
                    .then((res) => {
                        this.$store.dispatch('setToken', res);
                        this.$store.dispatch('getUser');
                        this.hasPhone = false;
                        this.handleLuckDraw();

                    }, (err) => {
                        this.$Message.error(err.data.message);
                    });
            },
            handleCode() {
                if (!this.phone) {
                    this.$Message.error('请输入手机号码');
                    return false;
                } else {
                    api.account.verify_img_code({
                        phone: this.phone,
                        messageType: 3
                    })
                        .then((res) => {
                            if (res) {
                                this.hasCode = true;
                                this.countDown();
                            }
                        });
                }
            },
            countDown() {
                let _self = this;
                let timeInterval = null;

                timeInterval = setInterval(() => {
                    if (parseInt(_self.timer) > 0 && parseInt(_self.timer) < 61) {
                        _self.timer -= 1;
                    } else {
                        this.hasCode = false;
                        clearInterval(timeInterval);
                    }
                }, 1000);

            },
            handleShare() {

            },
            jump(index) {
                let jump = document.querySelectorAll('.d_jump');
                let total = jump[index].offsetTop - 100;
                document.body.scrollTop = total;
                document.documentElement.scrollTop = total;
                window.pageYOffset = total;
            }
        },
        created() {

        },
    };
</script>
<style rel="stylesheet/scss" lang="scss">
    .egg {
        width: 100%;
        overflow-x: hidden;
        &-bd {
            &-one {
            }
            &-two {
                .egg-list {
                    height: 100%;
                    position: absolute;
                    width: 70%;
                    left: 50%;
                    margin-left: -35%;
                    &-col {
                        width: 25%;
                        height: 100%;
                        float: left;
                        cursor: pointer;
                    }
                }
            }
            &-three {
            }
            &-four {
            }
            &-five {
            }
            &-six {
            }
            &-seven {
                &-btn {
                    position: absolute;
                    width: 150px;
                    left: 50%;
                    margin-left: -75px;
                    cursor: pointer;
                }
            }
            &-eight {
            }
        }
        &-img {
            width: 100%;
            font-size: 0;
            display: block;
        }
        &-modal {
            width: 305px;

            .ivu-modal {
                top: 30%;
                &-content {
                    background-color: transparent;
                }
            }
            &-content {
                width: 305px;
                margin-left: auto;
                margin-right: auto;
                &-img {
                    width: 305px;
                    z-index: 1;
                }
                .egg {
                    &-close {
                        position: absolute;
                        top: 35px;
                        right: -3px;
                        z-index: 5;
                        width: 40px;
                        height: 40px;
                        cursor: pointer;
                    }
                    &-num {
                        position: absolute;
                        left: 126px;
                        top: 179px;
                        z-index: 5;
                        height: 40px;
                        color: #c06e5b;
                        font-size: 20px;
                        width: 40px;
                        text-align: center;
                    }
                    &-phone {
                        position: absolute;
                        left: 89px;
                        top: 214px;
                        z-index: 5;
                        color: #464646;
                        font-size: 11px;
                        &-text {
                            color: #c06e5b;
                            font-size: 12px;
                        }
                    }
                    &-app {
                        position: absolute;
                        left: 80px;
                        top: 253px;
                        z-index: 5;
                        width: 150px;
                        height: 50px !important;
                        cursor: pointer;
                        background: transparent;
                    }
                    &-share {
                        position: absolute;
                        left: 114px;
                        top: 286px;
                        z-index: 5;
                        width: 150px;
                        height: 50px;
                        cursor: pointer;
                        background: transparent;
                    }
                }
            }
            &-phone {

                .ivu-modal {
                    width: 370px !important;
                    top: 30%;
                    &-content {
                        background-color: transparent;
                    }
                }
                &-content {
                    width: 350px;
                    height: 250px;
                    background: #fff;
                    border-radius: 5px;
                    overflow: hidden;
                    .phone {
                        &-hd {
                            width: 100%;
                            height: 57px;
                            line-height: 57px;
                            text-align: center;
                            font-size: 20px;
                            background: #c09e5b;
                            color: #fff;
                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;
                            &-close {
                                position: absolute;
                                right: 10px;
                                top: 10px;
                                display: flex;
                                z-index: 5;
                            }
                        }
                        &-bd {
                            width: 250px;
                            margin-left: auto;
                            margin-right: auto;
                            .phone-input {
                                text-align: left;
                                input {
                                    background: #e3e3e3;
                                    font-size: 10px;
                                    height: 30px;
                                    text-indent: 10px;
                                    border-radius: 3px;
                                }
                            }
                        }
                        &-fd {
                            &-img {
                                width: 160px;
                            }
                        }
                    }
                    .phone-code {

                    }
                }
            }
        }
    }

    .button {
        cursor: pointer;
        &-egg {
            width: 83px;
            height: 30px !important;
            line-height: 30px !important;
            text-align: center;
            border: 1px solid #ad9663;
            color: #ad9663;
            transition: all .3s ease-in-out;
            font-size: 12px;
            border-radius: 5px;
            margin-top: 0 !important;
            margin-left: 8px;
            &-bg {
                width: 181px;
                height: 40px !important;
                line-height: 40px !important;
                background: url("https://chain-apply.oss-cn-shanghai.aliyuncs.com/egg/egg-13.png");
                background-repeat: no-repeat;
                background-size: contain;
                color: #fff;
            }
        }
    }

    .ivu-modal {
        width: 350px;
    }

    .rel {
        position: relative;
    }

    .mt {
        &10 {
            margin-top: 10px;
        }
        &15 {
            margin-top: 15px;
        }
        &20 {
            margin-top: 20px;
        }
    }

    .ml {
        &10 {
            margin-top: 10px;
        }
        &15 {
            margin-top: 15px;
        }
        &20 {
            margin-top: 20px;
        }
    }

    .dib {
        display: inline-block;
    }
</style>
